const chargingTransactionsErrorEnum = {
    ConnectorStatusNotAllowed: -1,
    FailedChargeConceptLimit: -2,
    FailedStartTransactionOnRemote: -3,
    FailedConnectWithRemoteServer: -999,
  };
  
  export default chargingTransactionsErrorEnum;
  